import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M18.83 9a3.001 3.001 0 1 1 0-2H21a1 1 0 1 1 0 2zM3 7h8v2H3a1 1 0 0 1 0-2m5 12a3 3 0 1 0-2.83-4H3a1 1 0 1 0 0 2h2.17A3 3 0 0 0 8 19m13-2h-8v-2h8a1 1 0 1 1 0 2"
    }
  )
);
var SvgPreferencesFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var PreferencesFilled_default = SvgPreferencesFilled;

export { PreferencesFilled_default as default };
